import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useCallback } from "react";
import { BreakpointsConsumer } from "../Breakpoints/BreakpointsProvider";
export var On = function(param) {
    var _renderIf = param.renderIf, renderIf = _renderIf === void 0 ? true : _renderIf, children = param.children;
    var checkPropFormat = useCallback(function(breakpointsAndDims) {
        if (typeof renderIf === 'boolean') {
            return renderIf;
        } else if (typeof renderIf === 'function') {
            return renderIf(breakpointsAndDims);
        }
        return true;
    }, [
        renderIf
    ]);
    return _jsx(BreakpointsConsumer, {
        children: function(breakpointsAndDims) {
            if (checkPropFormat(breakpointsAndDims)) {
                return children;
            }
            return null;
        }
    });
};
export default On;
